import { useEffect } from 'react'

/** Strips a leading "(12) " unread-count badge from a tab title, leaving the base title untouched. */
const stripBadge = (title: string) => title.replace(/^\(\d+\)\s*/, '')

/**
 * Prefixes the browser tab title with the total unread chat count (e.g. "(3) Backbone") while there
 * are unread messages, and restores the bare title when the count drops to zero or the widget unmounts.
 *
 * The base title is re-derived from `document.title` on every change (rather than captured once) so
 * any unrelated title updates the app makes elsewhere are preserved — we only ever own the "(n) " prefix.
 */
export const useDocumentTitleBadge = (unreadTotal: number) => {
  useEffect(() => {
    if (typeof document === 'undefined') return
    if (unreadTotal <= 0) return

    document.title = `(${unreadTotal}) ${stripBadge(document.title)}`

    return () => {
      document.title = stripBadge(document.title)
    }
  }, [unreadTotal])
}
